import { createSelector } from 'reselect'

const consentSelector = state => state.get('consentManagement')

export const getListConsent = createSelector(
    consentSelector,
    consentImmutable => {
      const consents = consentImmutable.toJS()
      return consents.consentList.consent
    }
)
export const getDeactivateConsentData = createSelector(
  consentSelector,
  consentImmutable => {
    const consents = consentImmutable.toJS()
    return consents.consentEdit
  }
)
export const getCreateConsentData = createSelector(
  consentSelector,
  consentImmutable => {
    const consents = consentImmutable.toJS()
    return consents.consentCreate
  }
)
export const getEditConsentData = createSelector(
  consentSelector,
  consentImmutable => {
    const consents = consentImmutable.toJS()
    return consents.consentEdit
  }
)
export const getGetConsentData = createSelector(
  consentSelector,
  consentImmutable => {
    const consents = consentImmutable.toJS()
    return consents.consentGet.consent
  }
)
export const getIsFetching = createSelector(
  consentSelector,
  consentImmutable => {
    const consents = consentImmutable.toJS()
    return consents.consentCreate.isFetching
    || consents.consentEdit.isFetching
    || consents.consentGet.isFetching
    || consents.consentList.isFetching
    //|| consents.companyExport.isFetching
  }
)
export const redirectCosent = createSelector(
  consentSelector,
  consentImmutable => {
    const consents = consentImmutable.toJS()
    return ({
      redirect: (consents.consentCreate.redirect
      || consents.consentEdit.redirect
      || consents.consentGet.redirect
      || consents.consentList.redirect
      || consents.consentExport.redirect),
      isAuthenticated: (consents.consentCreate.isAuthenticated
      || consents.consentEdit.isAuthenticated
      || consents.consentGet.isAuthenticated
      || consents.consentList.isAuthenticated
      || consents.consentExport.isAuthenticated),
    })
  }
)
export const getExportURL = createSelector(
  consentSelector,
  consentImmutable => {
    const consents = consentImmutable.toJS()
    return consents.consentExport.url
  }
)


// WEBPACK FOOTER //
// ./src/selectors/consent-management/consent-management-selector.js